﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const englishLabels: TranslationLabels = {
  Actions: "Actions",
  Actions_Activate: "Activate",
  Actions_Add: "Add",
  Actions_AddBoard: "Add board",
  Actions_AddComment: "insert comment",
  Actions_AddRun: "New run",
  Actions_AddTopic: "Add topic",
  Actions_Back: "Back",
  Actions_Cancel: "Cancel",
  Actions_ChangeRunStatus: "Change status",
  Actions_CreateEmail_Success: "Email successfully created.",
  Actions_Deactivate: "Deactivate",
  Actions_Delete: "Delete",
  Actions_DeleteBoard: "Delete board",
  Actions_DeleteRun: "Delete Run",
  Actions_DeleteRunTopic: "Delete topic",
  Actions_DownloadBoardsExcel: "Boards information",
  Actions_DownloadConfiguration: "Download configuration",
  Actions_DownloadFile: "Download file '{name}' …",
  Actions_DownloadRunDocuments: "get zip of all documents",
  Actions_DownloadRunDocuments_Empty: "There aren't files to download.",
  Actions_Edit: "Edit",
  Actions_EditBoard: "Edit board",
  Actions_EditComment: "edit comment",
  Actions_EditRun: "Edit run",
  Actions_EditTopic: "Update topic",
  Actions_GoToBoard: "Open committee settings",
  Actions_GoToRuns: "Open committee runs",
  Actions_GoToVote: "To the vote",
  Actions_Help: "Help",
  Actions_HideChildren: "Hide subordinate elements",
  Actions_HideDiff: "Hide differences",
  Actions_None: "None",
  Actions_Open: "Open",
  Actions_Opendocument: "open",
  Actions_OpenPhonebook: "Open phone book",
  Actions_OpenUserProfile: "Open user profile",
  Actions_PublishRun: "Send invitations and publish run",
  Actions_Refresh: "Refresh",
  Actions_Reset: "Reset",
  Actions_Save: "Save",
  Actions_SendEmail_Success: "Send Email Success.",
  Actions_SendReminders: "Send Reminders",
  Actions_SendSiveResults_Failure: "Can't send result to SiVe!",
  Actions_SendSiveResults_Success: "Send Result to SiVe Success.",
  Actions_SendToSive: "Send results to SiVe",
  Actions_ShowChildren: "Show subordinate elements",
  Actions_ShowDiff: "Show differences",
  Actions_Synchronize: "Synchronize",
  Actions_ToggleComments: "Show comments",
  Actions_ToggleResults: "Show results",
  Actions_ToggleTopics: "Expand/Collapse all topics",
  Actions_UploadDocument: "Add document",
  Actions_View: "Details",
  Actions_View_History: "Version history",
  Actions_ViewHistory: "View history",
  AddUser_Label: "Add user",
  AdminChart_Answered: "completely answered",
  AdminChart_NoResults: "There are not progress",
  AdminChart_NotAnswered: "not or not compoletely answered",
  Administration_Restriction: "You have to be admin to see that page.",
  AdministratorsHaveAccessToo: "The existing administrators of the application have access, too.",
  AdminUsersFilter_Placeholder: "Search for users …",
  AliasOptional: "Alias (optional)",
  Answer_Abstention: "Abstention",
  Answer_Acknowledged: "Acknowledged",
  Answer_Discussion_Required: "Discussion Required",
  Answer_Group_Done: "Done",
  Answer_Group_Todo: "To do",
  Answer_No: "No",
  Answer_Not_Answer: "No Answer",
  Answer_Response_Abstention: "Abstention: {{totalAnswer}}",
  Answer_Response_Acknowledged: "Acknowledged: {{totalAnswer}}",
  Answer_Response_Discussion_Required: "I request a discussion: {{totalAnswer}}",
  Answer_Response_No: "No, I not agree: {{totalAnswer}}",
  Answer_Response_Not_Answer: "Open: {{totalAnswer}}",
  Answer_Response_Yes: "Yes, I agree: {{totalAnswer}}",
  Answer_Response_Yes_But: "Yes But: {{totalAnswer}}",
  Answer_Yes: "Yes",
  Answer_Yes_But: "Yes But",
  App_Version: "Version",
  ApplicationName: "eDecide",
  AuditLog: "Audit log",
  AuditLog_Action: "Action",
  AuditLog_Add: "Added",
  AuditLog_After: "After",
  AuditLog_Before: "Before",
  AuditLog_Changes: "Changes",
  AuditLog_Created: "Date",
  AuditLog_CreatedBy: "User",
  AuditLog_Date: "On",
  AuditLog_Diff: "Differences",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Fields",
  AuditLog_Property: "Field",
  AuditLog_Remove: "Deleted",
  AuditLog_State: "Action",
  AuditLog_Update: "Updated",
  AuditLog_User: "By",
  AuditLogs: "Audit logs",
  Auth_Loading: "Loading application …",
  Auth_LoginFailed: "Login failed.",
  Auth_Redirecting: "Loading login …",
  Auth_TryAgain: "Try again.",
  BackHome: "Back to the home page",
  Board: "Board",
  Board_Description: "Description",
  Board_Members: "Members",
  Board_Members_Add: "Add member",
  Board_Name: "Name",
  Board_Owners: "Owners",
  Board_Owners_Add: "Add owner",
  Board_RunThresholdDays: "Archived runs older than {{runThresholdDays}} days are not displayed",
  Board_Status: "State",
  Board_Statuses: "States",
  Board_TopicKindCodes: "Available topic kinds",
  Board_UniqueId: "Key",
  BoardConfiguration: "Configuration",
  BoardConfiguration_Emailtemplate: "Email template",
  BoardConfiguration_ReportTemplate: "Report template",
  BoardRole: "Board role",
  BoardRole_Member: "Member",
  BoardRole_Owner: "Owner",
  BoardRoles: "Board roles",
  Boards: "Boards",
  Boards_Empty: "No board to display.",
  Boards_NotFound: "No boards were found with these criteria",
  BoardStatus_Active: "active",
  BoardStatus_Archived: "archived",
  BoardStatus_Inactive: "inactive",
  By: "by",
  Cancel: "Cancel",
  ClaimIssuer: "Claim issuer",
  Claims: "User claims",
  ClaimType: "Claim type",
  Confirm: "I confirm",
  Confirm_Cancel: "Cancel",
  Confirm_Content: "Unsaved changes detected. Do you really want to discard the changes?",
  Confirm_DeleteBoard_Text: "Delete board {{name}}?",
  Confirm_DeleteEmailTemplate_Text: "Delete email template {{name}}",
  Confirm_DeleteReportTemplate_Text: "Delete report {{name}}",
  Confirm_DeleteRun_Text: "Delete run {{title}}?",
  Confirm_Discard: "Discard changes",
  Confirm_RunStatus_Change: "Please confirm the status change from {oldStatus} to {newStatus}.",
  Confirm_RunStatus_Change_To_Archive_Title: "Archive run",
  Confirm_RunStatus_Change_To_Close: "Please confirm the change of status from '{oldStatus}' to 'closed'. If SiVe link (external ID) is present, the results will be transmitted automatically after closing.",
  Confirm_RunStatus_Change_To_Close_Title: "Close run",
  Confirm_RunStatus_Change_To_Publish_Title: "Publish run",
  Confirm_RunStatus_Change_To_Revise: "Please confirm the status change from «{oldStatus}» to «Revision». In the «Revision» status, the run properties such as end date and title can be adjusted and new participants can be added.",
  Confirm_RunStatus_Change_To_Revise_Title: "Revise run",
  Confirm_Title: "Unsaved changes",
  CopyToClipboard_Idle: "Copy to clipboard…",
  CopyToClipboard_Success: "Copied!",
  Created: "Created",
  Date_Group_All: "All",
  Date_Group_Oneyear: "maximum 1 year old",
  Date_Group_Twomonths: "maximum 2 months old",
  Date_Group_Twoyears: "maximum 2 years old",
  Date_Unknown: "Unknown date",
  De: "Deutsch",
  Details: "Details",
  DismissableDialog_Close_Label: "Close",
  DismissableDialog_Close_Tooltip: "Do not display message again",
  Download: "Download",
  Edit: "Edit",
  Email_Invitation_Subject: "eDecide run {{run.title}}",
  Email_Reminder_Publish: `{{boardName}} - eDecide run {{runTitle}}
This is an automatically generated email.<br><br>
Dear session participants<br><br>
The eDecide run has just been opened. Please cast your vote by {{expiryDate}} at {{expiryTime}}. <br><br>
Click on the following link to go directly to the voting page: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Best regards,<br><br>
{{boardOwnerName}}<br>
Board Administrator<br><br>

============================REPUBLISH============================


{{boardName}} - eDecide run {{runTitle}}
This is an automatically generated email.<br><br>
Dear session participants<br><br>
The eDecide run has just been reopened. Please cast your vote by {{expiryDate}} at {{expiryTime}}. <br><br>
Click on the following link to go directly to the voting page: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Best regards,<br><br>
{{boardOwnerName}}<br>
Session Administrator`,
  Email_Reminder_Subject: "Reminder {{title}}",
  EmptyTable: "No data available in table",
  En: "English",
  Entity: "Entity",
  Entity_Add_Failure: "{EntityName} could not be created.",
  Entity_Add_Success: "{EntityName} was created successfully.",
  Entity_Delete_ConfirmContent: "Do you really want to delete {EntityName}?",
  Entity_Delete_ConfirmTitle: "Confirm deletion",
  Entity_Delete_Failure: "{EntityName} could not be deleted.",
  Entity_Delete_Success: "{EntityName} deleted successfully.",
  Entity_Refresh_Failure: "{EntityName} could not be reloaded.",
  Entity_Refresh_Success: "{EntityName} reloaded successfully.",
  Entity_Save_Failure: "{EntityName} could not be saved.",
  Entity_Save_Success: "{EntityName} saved successfully.",
  Entity_Update_Failure: "{EntityName} could not be updated.",
  Entity_Update_Success: "{EntityName} updated successfully.",
  EntityCount: "# Entries",
  EntityTitle_Unknown: "Unknown",
  Error_FailedToAddUser: "User '{0}' could not be added.",
  ErrorCodes_BadRequest: "Something has gone wrong with the query. It is a client error (for example: incorrect query syntax, invalid framing of the query message, or misleading query routing).",
  ErrorCodes_InternalServerError: "An error occurred while processing your request.",
  ErrorCodes_NoResponse: "The backend service is not available.",
  ErrorCodes_NotFound: "The resource was not found.",
  ErrorCodes_Unauthorized: "You do not have permissions to access the resource.",
  Exception: "Exception",
  Exists: "Exists",
  File_Picker_Not_Valid_File: "Invalid file format!",
  FileAction_Delete: "Will be deleted",
  FileAction_Existing: "Existing",
  FileAction_New: "Will be uploaded",
  FileAction_Overwrite: "Will be overwritten",
  FileUpload_ProtectedFile_Message: "The uploaded file '{0}' was detected as encrypted.",
  FileUpload_ProtectedFile_Title: "Protected file will not be uploaded",
  Filter_Active_Icon_Tooltip: "Edit filter",
  Filter_Clear_Icon_Tooltip: "Clear filter",
  Filter_Combobox_Filter_Customize: "Filter",
  Filter_Icon_Tooltip: "Apply filter",
  Filter_Search_Placeholder: "Search…",
  Footer_HelpAndSupport: "Help & Support",
  Footer_HelpTitle: "SBB eDecide Help",
  Footer_Imprint: "Imprint",
  Footer_Title: "Imprint and help",
  Fr: "Français",
  Group: "Group",
  Group_Add: "Add group",
  Group_AddError: "Group could not be added",
  Group_AddSuccess: "Group was successfully added",
  Group_ConfirmDelete: "Do you really want to remove the group?",
  Group_DeleteError: "Group could not be removed",
  Group_EntraIdName: "Name in Entra Id",
  Group_EntraIdName_Description: "If you link an Entra ID group (Omada) group here, the members are imported periodically. If no link is defined, the members can be deleted and added to the right.",
  Group_Id: "Id",
  Group_MemberCount: "# Members",
  Group_Members: "Members",
  Group_Name: "Name",
  Group_Search: "Search for group …",
  Group_SearchStringHint: "The name of the AD Group is supported.",
  Group_Titles: "AD Groups",
  GroupMember_ExistsInGroup: "Exists in group",
  Groups: "Groups",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Help",
  Header_Italian: "Italiano",
  Header_Version: "Version",
  Help: "Help",
  HelpMenu_CosProductPage: "COS product eGPL 2",
  HelpMenu_Manuals: "Manuals",
  HelpMenu_Support: "Support",
  HelpMenu_VivaEngage: "Gruppo Viva Engage eGPL 2",
  Helppage: "Help",
  Home: "Home",
  Id: "Id",
  ImportedFromPhonebook: "Fields imported from phone book",
  It: "Italiano",
  KeywordSearch: "Keyword search",
  LastModified: "Last modified",
  LastModifiedBy: "Last modified by",
  LastSync: "Last synchronisation",
  Loading: "Loading …",
  Logout: "Logout",
  Message_Confirm_No: "NO",
  Message_Confirm_Question: "Are you sure you want to continue?",
  Message_Confirm_Yes: "YES",
  Modified: "Modified",
  Navigation_Administration: "Administration",
  Navigation_All_Boards: "All boards",
  Navigation_Completed_Votes: "Completed votes",
  Navigation_My_Boards: "My boards",
  Navigation_Open_Votes: "Open votes",
  No: "No",
  Ok: "OK",
  OpenLinkNewWindow: "Open link (in new window)",
  OriginalPath: "Request path",
  Page_Admin_Title: "Administration",
  Page_Board_Title: "Board «{0}»",
  Page_BoardEdit_Title: "Manage board «{{name}}»",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "User claims",
  Page_Dashboard_Title: "Dashboard",
  Page_Error_SubTitle: "An error occurred while processing your request.",
  Page_Error_Title: "Error",
  Page_Group_Title: "Group «{0}»",
  Page_Groups_Title: "Groups",
  Page_JobStatus_Title: "Job status",
  Page_Mails_Title: "Inxmail Testing",
  Page_Memory_Title: "Memory",
  Page_Resources_Title: "Translations",
  Page_Run_Title: "Run «{{title}}»",
  Page_Translations_Title: "Translations",
  Page_User_Title: "User «{0}»",
  Page_UserEdit_Title: "Edit user «{0}»",
  Page_Users_Title: "Users",
  Paging_First: "First",
  Paging_Last: "Last",
  Paging_Next: "Next",
  Paging_Previous: "Previous",
  Paging_Stats: "Showing _START_ to _END_ of _TOTAL_ entries",
  Paging_StatsFiltered: "(filtered from _MAX_ total entries)",
  Participant: "Participant",
  Participant_Answered_Stats: "answered {{answered}}/{{totalTopic}}",
  Participant_Answers: "Answers",
  Participant_Initials: "Initials",
  Participant_Name: "Name",
  Participant_Role: "Role",
  Participant_Status: "Status",
  Participants: "Participants",
  Permissions: "Permissions",
  Personalisation: "Personalisation",
  Preview_Report: "Preview report",
  Properties: "Properties",
  PublishRun_MailSubject: "Email subject",
  PublishRun_MailSubject_Reminder_To_All: "Dear run participants,<br><br>",
  PublishRun_MailText: "Email text",
  PublishRun_SendTo: "Receiver",
  PublishRun_SendType: "Sending method",
  RequestId: "Request ID",
  Reset: "Reset",
  RichText_Link_Dialog_Title: "Edit link",
  RichText_Link_Invalid_URL: "Please enter a valid URL (https://, http://, mailto:)",
  RichText_Link_Remove: "Remove link",
  RichText_Link_Text_Label: "Display text",
  RichText_Link_URL_Label: "Objective",
  RichText_Paste_Cancel_Tooltip: "Cancel (undo paste)",
  RichText_Paste_KeepFormatting_Tooltip: "Keep Formatting",
  RichText_Paste_Options_Trigger_Tooltip: "Paste Options (Ctrl)",
  RichText_Paste_PlainText_Tooltip: "Paste as Plain Text",
  Richtext_Placeholder: "Enter text …",
  RichText_Tooltip_Background: "Background color",
  RichText_Tooltip_Blockquote: "Format as a block quote",
  RichText_Tooltip_Bold: "Bold (Ctrl+B)",
  RichText_Tooltip_Clean: "Clear formatting",
  RichText_Tooltip_Color: "Foreground color",
  RichText_Tooltip_Heading: "Heading",
  RichText_Tooltip_Indent_Minus1: "Decrease indentation (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Increase indentation (Tab)",
  RichText_Tooltip_Italic: "Italic (Ctrl+I)",
  RichText_Tooltip_Link: "Add a link",
  RichText_Tooltip_List_Bullet: "Add a list",
  RichText_Tooltip_List_Ordered: "Add a ordered list",
  RichText_Tooltip_Script_Sub: "Subscript",
  RichText_Tooltip_Script_Super: "Superscript",
  RichText_Tooltip_Size: "Font size",
  RichText_Tooltip_Source: "View HTML source",
  RichText_Tooltip_Strike: "Strikethrough",
  RichText_Tooltip_Underline: "Unterline (Ctrl+U)",
  Run: "Run",
  Run_ArchivedBy: "Archived by",
  Run_ArchiveType: "Archive type",
  Run_Boardname: "Board",
  Run_ClosedBy: "Closed by",
  Run_ClosedDate: "Close time (effective)",
  Run_CloseType: "Close type",
  Run_Comment: "Comment",
  Run_Expirydate: "Expiry date",
  Run_Expirytime: "Expiry time",
  Run_Externalid: "External Id (SiVe)",
  Run_Key: "Id",
  Run_NotFound: "No run to display",
  Run_SiVeTransferResult: "SiVe transfer",
  Run_Status: "Status",
  Run_Title: "Title",
  RunParticipant: "Run participant",
  RunParticipant_NotFound: "User not available",
  RunParticipants: "Run participants",
  RunParticipants_Add: "Add participant",
  RunParticipants_Invalid: "Participant list incorrect",
  RunParticipants_SearchMember: "Search board members:",
  RunRole_AdditionalParticipant: "Additional participant",
  Runs: "Runs",
  Runs_Empty: "No runs found.",
  RunStatus_All: "All",
  RunStatus_Archived: "archived",
  RunStatus_ArchivedAndWillBeDeleted: "Archived, will be deleted on {0}",
  RunStatus_ClosedFromPublished: "closed",
  RunStatus_ClosedFromRepublished: "closed",
  RunStatus_Preparing: "preparing",
  RunStatus_Published: "published",
  RunStatus_Republished: "republished",
  RunStatus_Unknown: "Unknown",
  RunTopic: "Topic",
  RunTopic_Content: "Content",
  RunTopic_Documents: "Documents",
  RunTopic_InfoText: "Content (Infotext)",
  RunTopic_Number: "Topic number",
  RunTopic_Question: "Content (Question)",
  RunTopic_Result: "Result",
  RunTopic_Title: "Topic title",
  RunTopic_TopicKindCode: "Kind of topic",
  RunTopics: "Topics",
  RunTopics_Empty: "No topics found.",
  RunTopicType_Agenda_Content: "Agenda's question",
  RunTopicType_Decision_Content: "Question",
  RunTopicType_Info_Content: "Info text",
  RunTopicType_Protocol_Content: "Protocol's question",
  RunTopicVote: "Voting result",
  RunTopicVotes: "Voting results",
  Save: "Save",
  Select_Placeholder: "Select …",
  SelectAll: "Select all",
  Send_Mail_Download: "download Email",
  Send_Mail_Publish: "Publish",
  Send_Mail_Send: "send",
  Send_Mail_Send_Reminder_To_All: "The eDecide voting cycle has just been launched. Please vote before {{expiryDate}} at {{expiryTime}}.<br><br>",
  Send_Mail_Text: "Email text",
  SendTo_All: "All (participants and board administrators)",
  SendTo_BoardOwners: "Board-administrator",
  SendTo_Participants: "Participants",
  SendTo_ParticipantsWhoNotVoted: "Participants who have not yet voted",
  SendType_DoNotSend: "Not send E-Mails",
  SendType_Download: "Download email and send manually via Outlook",
  SendType_FromEdecide: "Send email directly from eDecide",
  Sive_MeetingDoesNotExist: "The run that you want to close does not exist in SiVe anymore!",
  Sive_MeetingMightBeDeleted: "The meeting in SiVe may no longer exist.",
  Sive_Result_IsSentOnClose: "The results will be send to SiVe when the run closes.",
  Sive_ResultsWereSent: "The results have been sent to SiVe when the run closed.",
  Sive_RunCreatedFromSive: "This run was created from a meing in SiVe.",
  Statistics: "Statistics",
  Status_All: "all",
  Status_Archived: "archived",
  Status_Button_Archive: "archive",
  Status_Button_Close: "Close run",
  Status_Button_Publish: "publish",
  Status_Button_Republish: "republish",
  Status_Button_Revise: "Revise",
  Status_Closed: "closed",
  Status_Preparing: "preparing",
  Status_Published: "published",
  Status_Republished: "republished",
  Status_Revise: "Revision",
  StatusCode_401_SubTitle: "You do not have access to the resource.",
  StatusCode_401_Title: "Access Denied",
  StatusCode_403_SubTitle: "You do not have permissions to access the resource.",
  StatusCode_403_Title: "Forbidden",
  StatusCode_404_SubTitle: "The resource was not found.",
  StatusCode_404_Title: "NotFound",
  Table_NoRows: "No records found.",
  Tag_Old: "Old",
  Today: "Today",
  Topic_Agenda: "Agenda",
  Topic_Decision: "Decision",
  Topic_Info: "Information",
  Topic_Protocol: "Protocol",
  TopicCode_Agenda_Content: "Agenda",
  TopicCode_Protocol_Content: "Protocol",
  Total: "Total",
  User: "User",
  User_AnonymizedDisplayName: "Deleted User",
  User_Boards: "Boards",
  User_DisplayName: "Name",
  User_Email: "Email",
  User_FirstName: "Firstname",
  User_Initials: "Initials",
  User_Initials_HelpText: `If you leave the field empty, the default will be applied.<br/>
First letter of first name, first letter of surname.`,
  User_Initials_Preview: "Preview",
  User_Language: "Language",
  User_LastName: "Lastname",
  User_LastSync: "Last synchronisation",
  User_OrganisationUnit: "Organisation unit",
  User_PersonalSiteUrl: "Personal site url (OneDrive)",
  User_PersonnelNumber: "Personnel-Nr.",
  User_Phone: "Phone",
  User_Status: "Status",
  User_Update_Error: "User could not be saved: {0}",
  User_Update_Success: "User has been saved",
  User_Upn: "Principal name",
  User_UserRoles: "Roles",
  UserMenu_MyDetails: "My profile",
  UserMenu_SignOut: "Sign out",
  UserPicker: "Pick user",
  UserPicker_NoDataTemplate: "No participant found",
  UserPicker_Placeholder: "Enter identifier …",
  UserRole_Administrator: "Administrator",
  UserRole_Application: "Application",
  UserRole_Unknown: "Unknown",
  UserRole_User: "User",
  Users: "Users",
  UserStatus_Deleted: "Deleted",
  UserStatus_Enabled: "Active",
  UserStatus_Unknown: "Unknown",
  Validation_At_Least_One_Owner: "Select at least one administrator.",
  Validation_Board_AtLeastOneBoardOwner: "Set at least one board owner.",
  Validation_Board_AtLeastOneUser: "Set at least one board member.",
  Validation_Board_DuplicateTopicKindCode: "Duplicate Kind of topic types are available.",
  Validation_Board_InvalidTopicKindCode: "Invalid Kind of topic types are available.",
  Validation_Board_NotUnique: "The board has to be unique. Check the field 'Name'.",
  Validation_Board_UniqueKeySizeNot12: "'UniqueKey' must be exactly 12 characters long.",
  Validation_Description_NotEmpty: "The description must not be empty.",
  Validation_ExpiryDate_Invalid: "Expiry date not valid!",
  Validation_InvalidPosition: "Cannot move. Invalid position.",
  Validation_Name_NotEmpty: "The name must not be empty.",
  Validation_Required: "'{PropertyName}' is required.",
  Validation_Run_CodesNotUnique: "RunTopic codes must be unique, found duplicates: [{0}].",
  Validation_Run_NotUnique: "Run has to be unique. Check the field 'Title'.",
  Validation_RunTopic_NotUnique: "The topic has to be unique. Check the field 'Topic number'.",
  Validation_TextLongerThanRecommended: "Recommended: no more than {{length}} characters.",
  Validation_Title_NotEmpty: "The title must not be empty.",
  ValidationFailures: "Validation errors",
  VoteChart_Answered: "Topic answered",
  VoteChart_NotAnswered: "Topic not answered",
  Votes_NotFound: "No votes were found with these criteria",
  Voting_MyAnswer: "My response",
  Voting_MyComment: "My comment",
  Voting_RunNotPublished: "This run is not published.",
  Yes: "Yes",
};
